import { createState, useState } from '@hookstate/core'
import { Persistence } from '@hookstate/persistence';
import { cloneDeep } from 'lodash';
import { UserInfo, UserNode } from '../../graphql/generated/graphql';

const initialState: UserInfo = {
  company: {},
  crew_members_projects: 0,
  producers_projects: 0,
  user: {},
};

const userInfoState = createState(initialState);
userInfoState.attach(Persistence('userInfo'));

export const setUserInfo = (userInfo: UserInfo) => {
  const tempUser = cloneDeep(userInfo);
  userInfoState.set({ ...tempUser });
};

export const setOnlyUserInfo = (user: UserNode) => {
  const tempUser = cloneDeep(user);
  userInfoState.user.set(tempUser)
}

export const useUserInfoState = () => useState(userInfoState);
